import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

// Page imports
import Login from "pages/login";
import Dashboard from "pages/dashboard";
import TransactionsManagement from "pages/transactions-management";
import FinancialReports from "pages/financial-reports";
import BankReconciliation from "pages/bank-reconciliation";
import ClientPortal from "pages/client-portal";
import TaxComplianceCenter from "pages/tax-compliance-center";
import UserManagement from "pages/user-management";
import ProductManagement from "pages/product-management";
//import QRCodeManagement from "pages/qr-code-management";
import Index from "pages/index";
import ProfileSettings from "pages/profile-setting";
import QRCodeManagement from "pages/qr-management";
import QrPinRecovery from "pages/qr-pin-recovery";
import { ScanlogProvider, useScanlog } from "contexts/scanlogContext.jsx";
import ScanlogModal from "pages/qr-management/components/ScanlogModal";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <ScanlogProvider>
          <GlobalScanlogModal />
          <RouterRoutes>
            <Route path="/admin" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/transactions-management" element={<TransactionsManagement />} />
            <Route path="/financial-reports" element={<FinancialReports />} />
            <Route path="/bank-reconciliation" element={<BankReconciliation />} />
            <Route path="/client-portal" element={<ClientPortal />} />
            <Route path="/tax-compliance-center" element={<TaxComplianceCenter />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/product-management" element={<ProductManagement />} />
            <Route path="/profile-settings" element={<ProfileSettings />} />
            <Route path="/qr-code-management" element={<QRCodeManagement />} />
            <Route path="/qr-pin-recovery" element={<QrPinRecovery />} />
            <Route path=":slug" element={<Index />} />
          </RouterRoutes>
        </ScanlogProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};


const GlobalScanlogModal = () => {
  const { showModal, allData, closeModal } = useScanlog();
  return showModal ? <ScanlogModal alldata={allData} onClose={closeModal}  /> : null;
}

export default Routes;